import FloatingFieldExamplePage from "./FloatingFieldExamplePage";

export default function FloatingFieldSmPage() {
  return <FloatingFieldExamplePage size="sm" />;
}
